import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useToken } from '../contexts/TokenContext';
import { getTenantId } from '@/services/tenantService';
import { setNewRelicUser } from '../observability/newrelic';

export const NewRelicInit = () => {
  const { idToken, tokenVersion } = useToken();

  useEffect(() => {
    if (!idToken) return;

    try {
      const decoded = jwtDecode(idToken);
      const participantId = decoded['custom:participantId'];
      if (!participantId) return;

      setNewRelicUser(participantId, {
        tenant_id: getTenantId() ?? ''
      });
    } catch (error) {
      console.error('Erro ao identificar usuário no NewRelic:', error);
    }
  }, [idToken, tokenVersion]);

  return null;
};
